import { render } from "./HomeEmailSms.vue?vue&type=template&id=bd957076&lang=true"
import script from "./HomeEmailSms.vue?vue&type=script&lang=js"
export * from "./HomeEmailSms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__